import React, { memo } from 'react';
import '../css/loader.css';
import tick from '../Components/Assets/tick.svg';
import Background from '../Components/background/background';
import { useLocation } from "react-router-dom";
import BackgruseRedirectIfNotLoggedIn from '../Components/redirect/redirect';
import config from '../Context/Config';


const FormSubmitted = memo(() => {
    const location = useLocation();
    const { openedViaLogin = false } = location.state || {};

    BackgruseRedirectIfNotLoggedIn(openedViaLogin);
    config.accessToken = null;

    return (
        <div className="relative h-screen w-screen bg-gradient-to-br from-red-50 to-orange-50 overflow-hidden">

            {/* Background Animation */}
            <Background />

            {/* Center Content */}
            <div className="absolute inset-0 flex items-center justify-center p-3">
                <div className="bg-white/90 backdrop-blur-sm p-4 sm:p-6 rounded-xl shadow-lg border border-green-100 text-center max-w-xs sm:max-w-md w-full">

                    {/* Icon Section */}
                    <div className="relative mb-4">
                        <div className="absolute inset-0 bg-green-100 rounded-full w-24 h-24 sm:w-28 sm:h-28 mx-auto animate-pulse opacity-40"></div>

                        <img
                            src={tick}
                            alt="Success"
                            className="relative mx-auto w-24 h-20 sm:w-28 sm:h-24 object-contain"
                            loading="lazy"
                        />
                    </div>

                    {/* Text Section */}
                    <div>
                        <h1 className="text-lg sm:text-xl font-bold text-green-600 mb-2 flex items-center justify-center gap-1">
                            <svg className="w-5 h-5 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                                <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Form Submitted
                        </h1>

                        <p className="text-green-700 text-xs sm:text-sm font-medium leading-snug mb-2">
                            Your form has been successfully submitted. We look forward to seeing you at the clinic!
                        </p>

                        <p className="text-green-600 text-xs sm:text-sm">
                            You may now close this window.
                        </p>
                    </div>

                </div>
            </div>
        </div>

    );
});

// Set display name for better debugging
FormSubmitted.displayName = 'Form Submitted';

export default FormSubmitted;